export default __webpack_public_path__ + "static/media/fata.5de84c4f.png";